import React from 'react';
import ModerationWorkflowsSection from '../../../sections/AdminDashboard/Moderation/ModerationWorkflows';

const ModerationWorkflows = () => {
  return <ModerationWorkflowsSection />;
};

export default ModerationWorkflows;

